/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkMoveJobFailure } from './bulkMoveJobFailure';

export interface BulkMoveJobResponse {
  id: string;
  status: string;
  total: number;
  push_eligible: number;
  push_ok: number;
  push_failed: number;
  failures?: BulkMoveJobFailure[];
  error_message?: string | null;
  finished_at?: string | null;
}
